export const ELECTRONIC_DOCUMENTS_CONTAINER_TAG_NAME = 'electronic-documents-container';
